import { Box } from '@mui/material'
import { BasePopover, usePopover } from 'feedback'
import { ICONE } from 'icons'
import { BaseIconButtons } from 'inputs'
import { BaseScatolaConTitolo } from 'layout'
import ModificaUrlServer from '../network/ModificaUrlServer'

export default function OpzioniSviluppatori() {
  const { popoverRef, openPopover } = usePopover()

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          right: 0,
          bgcolor: 'common.white',
          borderTopWidth: 2,
          borderTopColor: 'info.main',
          borderTopStyle: 'solid',
          borderLeftWidth: 2,
          borderLeftColor: 'info.main',
          borderLeftStyle: 'solid',
          borderRadius: 0,
          borderTopLeftRadius: 16
        }}
      >
        <BaseIconButtons.Custom
          contenutoTooltip='Opzioni per sviluppatori'
          Icon={ICONE.CODICE}
          color='info'
          onClick={openPopover}
          sx={{ m: 0 }}
        />
      </Box>

      <BasePopover
        ref={popoverRef}
        PaperProps={{ sx: { p: 2 } }}
      >
        <BaseScatolaConTitolo titolo='Configurazione backend'>
          <ModificaUrlServer />
        </BaseScatolaConTitolo>
      </BasePopover>
    </>
  )
}